import BaseController from '../base_controller'

export default class extends BaseController {

  static targets = [
    ...super.targets,
    'notSmokingDeclaration',
    'stoppedSmokingDeclaration',
    'currentlySmokingDeclaration'
  ]

  // ==== Actions

  changeSmokingHabits({ detail }) {
    this.toggleTarget(this.notSmokingDeclarationTarget, this.#notSmoking(detail))
    this.toggleTarget(this.stoppedSmokingDeclarationTarget, this.#stoppedSmokingRecently(detail))
    this.toggleTarget(this.currentlySmokingDeclarationTarget, this.#currentlySmoking(detail))
  }

  // ==== Private

  #notSmoking({ smokingHabits, ...detail }) {
    return smokingHabits === 'never_been_a_smoker' || (
      smokingHabits === 'used_to_be_a_smoker' &&
      this.#stoppedSmokingTwelveMonthsAgo(detail)
    )
  }

  #stoppedSmokingRecently({ smokingHabits, ...detail }) {
    return smokingHabits === 'used_to_be_a_smoker' &&
    !this.#stoppedSmokingTwelveMonthsAgo(detail)
  }

  #currentlySmoking({ smokingHabits }) {
    return smokingHabits === 'currently_a_smoker'
  }

  #stoppedSmokingTwelveMonthsAgo({ smokingStoppedYear, smokingStoppedMonth }) {
    if (!smokingStoppedYear) return false

    const now = new Date()
    const lastYear = now.getFullYear() - 1
    if (smokingStoppedYear < lastYear) return true
    if (smokingStoppedYear > lastYear) return false
    if (!smokingStoppedMonth) return false

    return smokingStoppedMonth < now.getMonth() + 1
  }

}
